module.exports = __webpack_public_path__ + "img/service-nongmaozonghe3.8495dfb4.svg";